module.exports = __webpack_public_path__ + "footer-logo-maire.png?e3fa7cfd0eb44d263db65e358b46096c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-maire.png
// module id = 32
// module chunks = 0